module.exports = __webpack_public_path__ + "static/media/4.IPhone_4.418ba628.png";